import { GetStaticProps } from "next";
import Head from "next/head";

import ReleasePage from "../../components/Releases/ReleasePage";

import {
  getStaticPropsForPostsPage,
  PostsPageProps,
  PostType,
} from "../../utils/posts";
import { FlashPCBPage } from "../../models/page";

const PressReleasesPage: FlashPCBPage<PostsPageProps> = ({ posts }) => {
  return (
    <>
      <Head>
        <title>Press Releases</title>
        <meta name="description" content="FlashPCB press releases" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ReleasePage title="Press" posts={posts} />
    </>
  );
};

export const getStaticProps: GetStaticProps = getStaticPropsForPostsPage(
  PostType.PRESS,
);

export default PressReleasesPage;
